<template>
    <editor v-if="$root.edit && $parent.isSelected" v-model="localHtml" @input="onChange" :bubble="true" />
    <div v-else v-html="parsedHtml" />
</template>

<script>
import Editor from '../components/Editor.vue'
export default  {
    name: 'zoezi-text-next',

    zoezi: {
        title: 'Text with an editor',
        icon: 'mdi-card-text-outline'
    },

    components: {
        Editor
    },

    computed: {
        parsedHtml() {
            return this.html?.replace(/{(.*?)}/gi, (match, content) => this.getProperty(content));
        }
    },

    data: () => ({
        localHtml: ''
    }),

    props: {
        html: {
            title: 'HTML',
            type: String,
            fulltype: 'html'
        }
    },

    watch: {
        html: {
            immediate: true,
            handler() {
                this.localHtml = this.html;
            }
        }
    },

    methods: {
        onChange(html) {
            this.$emit('silentsave', {html});
        },
        getProperty(name) {
            if (this.$store.state.user && this.$store.state.user[name] !== undefined) {
                return this.$store.state.user[name];
            } else {
                return '';
            }
        }
    }
}
</script>
